export class CloudCustomer {
  customerId?: string;
  name?: string;
  description?: string;
  connectAccountId?: string;
  creationTime?: Date;
}
